/* Tatagaltier wishlist page — build-spec §5 #8.
   Reveals the products saved in localStorage (`tata:wishlist`), shows an empty
   state when there are none, and stays in sync with heart toggles anywhere on the
   page via the `tata:wishlist:change` event dispatched by tata-card.js. */
(function () {
  var KEY = 'tata:wishlist';

  function saved() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }

  var page = document.querySelector('[data-tata-wishlist-page]');
  if (!page) return;
  var grid = page.querySelector('[data-wishlist-grid]');
  var empty = page.querySelector('[data-wishlist-empty]');
  var countEl = page.querySelector('[data-wishlist-count]');
  var items = grid ? grid.querySelectorAll('.tata-grid__item[data-product-handle]') : [];

  function render() {
    var list = saved();
    var shown = 0;
    items.forEach(function (item) {
      var on = list.indexOf(item.dataset.productHandle) !== -1;
      item.hidden = !on;
      if (on) shown++;
    });
    if (empty) empty.hidden = shown > 0;
    if (grid) grid.hidden = shown === 0;
    if (countEl) {
      countEl.hidden = shown === 0;
      countEl.textContent = shown + (shown === 1 ? ' saved item' : ' saved items');
    }
  }

  render();
  document.addEventListener('tata:wishlist:change', render);
})();
